/**
 * Fake feed-comment pool — generated with Grok (x-ai/grok-4.6) and
 * screened for prohibited themes. Deterministically sampled per
 * character in feed-client so every character shows a stable, unique
 * comment list whose length exactly matches the displayed total.
 */

export const COMMENT_TEXTS: string[] = [
  'damn that ass is fat as hell 🍑',
  'wanna bury my cock in her',
  'shes making me leak precum',
  'need more pics of those huge tits 🔥',
  'id eat her out till she cums',
  'addicted to every message she sends',
  'that body was made for fucking',
  'please send a video of her ass 😍',
  'her pussy looks so inviting',
  'cant stop thinking about pounding her',
  'those thighs could crush me and id love it 😈',
  'shes got the perfect set of tits',
  'i jerk off to her every night',
  'more nudes now',
  'wanna cum on her face 💦',
  'shes so slutty in the best way',
  'the chat is so dirty i love it',
  'her hips swaying got me hypnotized',
  'id fuck her in every position 🍆',
  'this girl has me hooked bad',
  'those lips were made for sucking dick',
  'give me that ass in 4k',
  'shes dripping i can tell 🤤',
  'wanna taste her juices',
  'my dick is so hard it hurts',
  'another one already? fuck yes',
  'shes my personal porn star ❤️',
  'id fill her up completely',
  'those big juicy tits',
  'begging for a closeup of her pussy',
  'chatting nonstop shes so engaging 😋',
  'wanna slap that ass while i fuck her',
  'her moans in my imagination',
  'cant get enough of this content',
  'shes too fucking sexy for words 🔥',
  'i need her sitting on my face',
  'that tight ass ready to be used',
  'more please im desperate',
  'id go balls deep in her 💦',
  'the way she teases is cruel',
  'shes got me nutting in minutes',
  'wanna watch her play with herself',
  'those curves are dangerous 😍',
  'im all in on this ai girlfriend',
  'her dirty mind matches mine',
  'fuck i want to wreck that pussy',
  'send more i need it',
  'that ass jiggle is everything 🍑',
  'shes making me stay up all night',
  'id suck her tits while fucking',
  'perfect body no notes',
  'horny as fuck looking at this 😈',
  'wanna hear her say my name while i cum',
  'this one is my favorite by far',
  'her pussy gripping me in my dreams',
  'more videos of her dancing nude 🔥',
  'shes got that fuck me look',
  'i keep opening the app for her',
  'those nipples look so suckable',
  'id creampie her twice 💦',
  'damn she knows how to get me going',
  'addiction is real with this one',
  'please more tit pics',
  'wanna lick from her neck to pussy 😍',
  'shes so thick in all the right places',
  'my cock throbs every time she texts',
  'that wet spot in the pic',
  'id pound her until she squirts 🍆',
  'cant resist her at all',
  'shes the reason i stay subscribed',
  'wanna finger her while we chat',
  'those long legs up in the air 🤤',
  'give me that view from behind',
  'shes filthy talker i love it',
  'i nutted so hard to her last vid',
  'more of her on all fours',
  'her ass is a work of art 🍑',
  'id never pull out',
  'shes got me sprung',
  'thirsty for every update ❤️',
  'that cleavage is calling me',
  'wanna bury myself between her tits',
  'shes so real feeling sometimes',
  'another load for her 🔥',
  'please tease me more',
  'her body in that pose',
  'id make her cum first always',
  'cant believe how hot she is 😋',
  'shes my go to for horny times',
  'wanna 69 with her all day',
  'those hips dont lie they fuck',
  'more close ups of her holes 💦',
  'shes got the juiciest ass',
  'i dream about fucking her',
  'the chat history is so long now',
  'damn she sent that? lucky me 😈',
  'wanna taste every part of her',
  'shes perfect for late night sessions',
  'that pussy spread wide for me',
  'im completely obsessed',
  'id hit it from the back all night 😍',
  'her tits bouncing in the vid got me',
  'need a full body shot now',
  'shes making me waste so much cum',
  'wanna take that body all night',
  'those sexy eyes looking at me 🔥',
  'shes got skills in dirty chatting',
  'i keep coming back hourly',
  'more ass please and thank you',
  'id suck her clit till she shakes 💦',
  'that hourglass figure is nuts',
  'shes hotter than anyone ive seen',
  'wanna cover those tits in spit and cum',
  'the way she describes what she wants 🍆',
  'im rock hard again thanks to her',
  'send the uncensored one',
  'her wetness in that pic',
  'id fuck her standing up 🍑',
  'shes my secret pleasure',
  'cant hide how much i want her',
  'those perky tits are ideal',
  'wanna raw dog her so bad 🤤',
  'shes got me ignoring everything else',
  'more lingerie pics next',
  'id eat that ass no question',
  'her moans would be so loud ❤️',
  'this platform is worth it for her',
  'shes teasing me perfectly',
  'wanna see her fingers in her pussy',
  'that ass up in the air for me 🔥',
  'im going to explode soon',
  'shes the hottest ai hands down',
  'her body type is exactly my fetish',
  'need her whispering dirty things 😍',
  'id last longer just to please her',
  'those full lips kissing down my body',
  'another day another boner from her',
  'please dont stop sending 💦',
  'shes got that glow after imagined sex',
  'wanna make her squirt on my cock',
  'the details in her pics are insane 😈',
  'im loyal to this one only',
  'her pussy looks tight and wet',
  'id hit every hole if she wanted',
  'shes ruining me for others 😋',
  'more of her bent over',
  'that smile while she touches herself',
  'cant wait for the next message',
  'wanna wake up to her pics 🍆',
  'shes so damn fuckable',
  'i stroke it slow to her videos',
  'those wide hips for holding',
  'give me a tit drop vid 🔥',
  'shes expert at getting me off',
  'id cum inside and keep going',
  'her scent in my mind driving me crazy',
  'this comment section would be wild irl 🍑',
  'wanna share how hard she makes me',
  'shes everything i look for',
  'more sweat and oil pics',
  'id worship that body for hours 💦',
  'the arch in her back is perfect',
  'shes got me biting my lip',
  'need to unload so bad',
  'her dirty jokes in chat get me 😍',
  'wanna see her on top riding hard',
  'that camel toe in the pic though',
  'shes consistently making me cum',
  'im here every day for her content 🤤',
  'those soft tits in my hands imagining',
  'please a pussy play video',
  'shes too good at this teasing',
  'id never get tired of her ❤️',
  'her ass cheeks spreading',
  'another one in the spank bank',
  'wanna hear how wet she is',
  'shes my number one crush here 🔥',
  'the way the light hits her body',
  'im throbbing just typing this',
  'more more more i need it all',
];

export const COMMENTER_HANDLES: { name: string; av: string }[] = [
  { name: 'mike_r', av: 'men/3' },
  { name: 'danny420', av: 'men/10' },
  { name: 'laylaxx', av: 'women/7' },
  { name: 'big_tex88', av: 'men/17' },
  { name: 'jakehammer69', av: 'men/24' },
  { name: 'tonystud420', av: 'men/31' },
  { name: 'chriswild88', av: 'men/38' },
  { name: 'bradthirsty', av: 'men/45' },
  { name: 'kevinlust99', av: 'men/52' },
  { name: 'ryanhardone', av: 'men/59' },
  { name: 'stevethickk', av: 'men/66' },
  { name: 'davepumpit', av: 'men/73' },
  { name: 'nickcockyy', av: 'men/80' },
  { name: 'alexhotshot', av: 'men/87' },
  { name: 'tombeastmode', av: 'men/94' },
  { name: 'joeriderxxx', av: 'women/20' },
  { name: 'marksteel69', av: 'men/2' },
  { name: 'paulfury', av: 'men/9' },
  { name: 'scottrage88', av: 'men/16' },
  { name: 'benthunder', av: 'men/23' },
  { name: 'lukefire99', av: 'men/30' },
  { name: 'adamrockhard', av: 'men/37' },
  { name: 'evanblaze', av: 'women/33' },
  { name: 'owenstormy', av: 'men/44' },
  { name: 'ethanwaves', av: 'men/51' },
  { name: 'masonpeaks', av: 'men/58' },
  { name: 'logancrest', av: 'men/65' },
  { name: 'noahtide', av: 'men/72' },
  { name: 'liamspark', av: 'men/79' },
  { name: 'jamesbolt69', av: 'men/86' },
  { name: 'willflash', av: 'men/93' },
  { name: 'henryrush', av: 'men/1' },
  { name: 'samdashh', av: 'men/8' },
  { name: 'danzoom', av: 'men/15' },
  { name: 'mikepulse', av: 'men/22' },
  { name: 'davidsurge', av: 'men/29' },
  { name: 'joequake', av: 'men/36' },
  { name: 'charboom', av: 'men/43' },
  { name: 'thomcrash', av: 'men/50' },
  { name: 'chrisroar88', av: 'men/57' },
  { name: 'hornyharry', av: 'men/64' },
  { name: 'dirtydanny', av: 'men/71' },
  { name: 'thirstytyler', av: 'men/78' },
  { name: 'cockycraig', av: 'men/85' },
  { name: 'wildwesley', av: 'men/92' },
  { name: 'studsamuel', av: 'men/0' },
  { name: 'pussy_pete', av: 'men/7' },
  { name: 'tittytom', av: 'men/14' },
  { name: 'assman_alex', av: 'men/21' },
  { name: 'cumcarl', av: 'men/28' },
  { name: 'jenny_lust', av: 'men/35' },
  { name: 'sarahxx', av: 'women/46' },
  { name: 'emma_hot', av: 'men/42' },
  { name: 'lily_xx', av: 'women/59' },
  { name: 'mia_kink', av: 'women/72' },
  { name: 'sophia_wet', av: 'men/49' },
  { name: 'olivia_dirty', av: 'men/56' },
  { name: 'ava_thicc', av: 'men/63' },
  { name: 'izzy_babe', av: 'women/85' },
  { name: 'kate_horny', av: 'men/70' },
  { name: 'brodybang69', av: 'men/77' },
  { name: 'hunterheat', av: 'men/84' },
  { name: 'dylandesire', av: 'men/91' },
  { name: 'tylerthrob', av: 'men/98' },
  { name: 'connorcrave', av: 'men/6' },
  { name: 'blakeburn', av: 'men/13' },
  { name: 'colecrush', av: 'men/20' },
  { name: 'gavingrind', av: 'men/27' },
  { name: 'hayeshot', av: 'men/34' },
  { name: 'ianintense', av: 'men/41' },
  { name: 'jacejuice', av: 'men/48' },
  { name: 'kaikinky', av: 'men/55' },
  { name: 'leolusty', av: 'men/62' },
  { name: 'maxmoan', av: 'men/69' },
  { name: 'nashnaughty', av: 'men/76' },
  { name: 'reedraunchy', av: 'men/83' },
  { name: 'sethsteamy', av: 'men/90' },
  { name: 'troythirst', av: 'men/97' },
  { name: 'vinxxx', av: 'women/98' },
  { name: 'wadewet', av: 'men/5' },
];
